import { render, staticRenderFns } from "./HangYeZhanBi.vue?vue&type=template&id=24646660&scoped=true&"
import script from "./HangYeZhanBi.vue?vue&type=script&lang=js&"
export * from "./HangYeZhanBi.vue?vue&type=script&lang=js&"
import style0 from "./HangYeZhanBi.vue?vue&type=style&index=0&id=24646660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24646660",
  null
  
)

export default component.exports